// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 127,
  argument: "The fear of God is the way to happiness.",
  verses: [
    { n: 1, text: "A gradual canticle. Blessed are all they that fear the Lord; that walk in his ways." },
    { n: 2, text: "For thou shalt eat the labours of thy hands: blessed art thou, and it shall be well with thee." },
    { n: 3, text: "Thy wife as a fruitful vine, on the sides of thy house. Thy children as olive plants round about thy table." },
    { n: 4, text: "Behold, thus shall the man be blessed that feareth the Lord." },
    { n: 5, text: "May the Lord bless thee out of Sion: and mayst thou see the good things of Jerusalem all the days of thy life." },
    { n: 6, text: "And mayst thou see thy children's children, peace upon Israel." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Canticle. Being a sequel to the former [psalm], (Calmet) and similar to the 111th, as both promise felicity to the captives at their return, if they prove faithful, 2 Esdras ix. 38. (Ferrand.) — It is a sort of epithalamium. (Moller.) — Both temporal and spiritual blessings are set before us. (Berthier) — Ways. Many saints have not received temporal rewards; and this confirms our faith that there is a world to come. (Calmet) — In effect, no temporal advantages are here specified, as they are below.", attribution: "Berthier" }
    ] },
    { verse: 2, notes: [
      { text: "Hands. The idle are not entitled to blessings, which God will bestow on the industrious who fear him, preserving them from evils, Leviticus xxvi. 16., and Deuteronomy xxviii. 30. (Calmet) (2 Corinthians iii. 10.) — Some have explained karpon, \"fruits:\" though it here means hands.", attribution: "Berthier" }
    ] },
    { verse: 3, notes: [
      { text: "Sides. Against which vines were planted. (Calmet) — The married people who fear God, shall commonly have a numerous posterity; or their souls shall produce many good works in the Church, which springs from our Saviour's side. Children denote such good works. (Worthington) — Plants. Psalm cxliii. 12.", attribution: "Homer, Odyssey vi. 163." }
    ] },
    { verse: 5, notes: [
      { text: "Sion. Where he displayed his bounty. (Calmet) — Jerusalem. In heaven, 1 Corinthians xv. 19. (Berthier) — Mayst thou live happily in the holy city, after thy long captivity.", attribution: "Calmet" }
    ] },
    { verse: 6, notes: [
      { text: "Israel. This is best secured by a well-regulated and numerous people. (Berthier) — The good works, performed on earth, will be rewarded in heaven. (Worthington) — We shall rejoice in the spiritual children, whom we shall have begotten.", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
